import { useState, useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";

const useAuth = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const fetchUser = async (token) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}auth/`,
        { token }
      );
      setUser(response.data);
    } catch (error) {
      console.error("Failed to fetch user:", error);
      setUser(null);
    }
  };
  // New function to update user manually
  const updateUser = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem("userInfo", JSON.stringify(updatedUser)); // Update localStorage
  };

  const login = async (email, password) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}auth/login/`,
        { email, password }
      );
      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        await fetchUser(response.data.token);
      }
      return response;
    } catch (error) {
      console.error("Failed to login:", error);
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userType");
    setUser(null);
    navigate("/login"); // Redirect to login page
  };

  const checkTokenExpiration = () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        if (decoded.exp <= currentTime) {
          logout(); // Log the user out if the token has expired
        }
      } catch (error) {
        console.error("Failed to decode token:", error);
        logout(); // Handle invalid token
      }
    }
  };

  useEffect(() => {

    const token = localStorage.getItem("token");

    if (token) {
      fetchUser(token);
    }

    // Periodic check for token expiration
    const interval = setInterval(() => {
      checkTokenExpiration();
    }, 1000); // Check every second
    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  return { user, login, logout, fetchUser, updateUser };
};

export default useAuth;
